import { createApp } from "vue";
import TlbsMap from "tlbs-map-vue";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "element-plus/theme-chalk/display.css";
import scui from "./scui";
import i18n from "./locales";
import router from "./router";
import store from "./store";
import App from "./App.vue";
import "./utils/time";
import "./utils/versionPolling";

const app = createApp(App);

app.use(store);
app.use(router);
app.use(TlbsMap);
app.use(ElementPlus);
app.use(i18n);
app.use(scui);
// TODO 按钮级别权限
// app.directive('has', {
//   inserted(el, binding, vnode) {
//     // 获取当前组件的名称
//     const currentPage = vnode.context.$options.name;
//     const permission = binding.value; // 获取指令的值
//     // 从 localStorage 中获取用户权限
//     const userPermissions = (JSON.parse(localStorage.getItem('userInfoAuth')))[currentPage] || [];
//     // 检查是否有权限
//     if (!userPermissions.includes(permission)) {
//       el.parentNode && el.parentNode.removeChild(el); // 没有权限则移除元素
//     }
//   },
// });

//挂载app
app.mount("#app");
